export const isDefined = (thing) => typeof thing !== 'undefined';

/**
 * Set document title.
 *
 * @param {*} title
 */
export const setDocumentTitle = (title) => (document.title = title);
